<script>
  import { createEventDispatcher } from 'svelte'
  import Shimmer from './Shimmer.svelte'
  export let reviewMedia = []
  export let mediaLimit = 3
  export let reviewId
  export let style = ''
  export let shimmerNumber = 0
  export let isGridLayout = false

  const NUMBER_OF_COLUMNS = 4

  const dispatch = createEventDispatcher()
  const ENTER_KEY = 13

  const addOverlay = index => {
    if (reviewMedia.length > mediaLimit && index === mediaLimit - 1) {
      return true
    }
    return false
  }

  const hideMedia = index => {
    if (index > mediaLimit - 1) {
      return true
    }
  }

  const handleClick = (index, reviewMedia) => {
    dispatch('selectMedia', {
      currentMedia: { index, reviewMedia },
      currentReviewId: reviewId
    })
  }

  const handleOpenModalWithEnterKey = (e, i, reviewMedia) => {
    if (e.keyCode === ENTER_KEY) {
      handleClick(i, reviewMedia)
    }
  }

  const isLastColumnElement = columnNumber =>
    columnNumber % NUMBER_OF_COLUMNS === 0
</script>

<style>
  .review-media {
    padding-top: 20px;
  }

  .media-box {
    position: relative;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
    text-align: center;
    width: 64px;
    height: 64px;
    border: 1px solid #edeff0;
    border-radius: 4px;
    margin-right: 14px;
    cursor: pointer;
  }

  .media-box img,
  .media-box video {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }

  .media-box.more::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    background: #34495e;
  }

  .media-box.more p {
    font-size: 16px;
    position: absolute;
    z-index: 2;
    display: inline-block;
    color: #fff;
    margin: auto;
    left: 0;
    right: 0;
  }

  .hide-media {
    display: none !important;
    pointer-events: none;
  }

  .media-box-grid {
    width: 42px;
    height: 42px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 4px;
    border: none;
  }

  .play-button {
    background-image: url(https://statics2.kudobuzz.com/icons/icon-video.svg) !important;
    background-repeat: no-repeat !important;
    width: 50% !important;
    height: 50% !important;
    position: absolute !important;
    left: 0% !important;
    right: 5% !important;
    top: 0% !important;
    bottom: 0% !important;
    margin: auto !important;
    background-size: contain !important;
    background-position: center !important;
    pointer-events: none !important;
  }
</style>

<div class="$style.review-media" {style}>
  {#each reviewMedia as media, i}
    {#if addOverlay(i)}
      <div
        tabindex="0"
        role="button"
        aria-label=" Click to review media to open modal"
        class="$style.media-box more"
        class:hide-media={hideMedia(i)}
        on:click={() => handleClick(i, reviewMedia)}
        on:keyup={e => handleOpenModalWithEnterKey(e, i, reviewMedia)}>
        <p>+{reviewMedia.length - mediaLimit}</p>
        {#if media.media_type === 'image'}
          <img
            src={media.url}
            alt="review media"
            id={media.id}
            onerror="this.closest('div').style='display:none !important'"
            data-index={i} />
        {:else}
          <video
            onerror="this.closest('div').style='display:none !important'"
            id={media.id}
            class="$style.review-video"
            width="64"
            height="64"
            data-index={i}
            src="{media.url}#t=0.1">
            <track kind="captions" />
          </video>
        {/if}
      </div>
    {:else}
      <div
        tabindex="0"
        role="button"
        aria-label=" Click to review media to open modal"
        class="$style.media-box"
        class:$style.media-box-grid={isGridLayout}
        style={isGridLayout && isLastColumnElement(i + 1) ? 'margin-right: 0;' : ''}
        class:hide-media={hideMedia(i)}
        on:click={() => handleClick(i, reviewMedia)}
        on:keyup={e => handleOpenModalWithEnterKey(e, i, reviewMedia)}>
        {#if media.media_type === 'image'}
          <img
            src={media.url}
            alt="review media"
            id={media.id}
            data-index={i}
            onerror="this.closest('div').style='display:none !important'" />
        {:else}
          <video
            onerror="this.closest('div').style='display:none !important'"
            id={media.id}
            class="$style.review-video"
            width="64"
            height="64"
            data-index={i}
            src="{media.url}#t=0.1">
            <track kind="captions" />
          </video>
          <div class="$style.play-button" />
        {/if}
      </div>
    {/if}
  {/each}
  {#if shimmerNumber}
    <Shimmer number={shimmerNumber} />
  {/if}
</div>
